// extracted by mini-css-extract-plugin
export default {"container":"CartBundleOrders_container__Kdd0L","heading":"CartBundleOrders_heading__FLEJF"};